import { apiClient } from '@/core/api';
import type { RealtimeTokenDto, SubscribeTokenDto } from './types';

/** `POST /api/realtime/token/` — the connection JWT for the active membership. */
export async function getRealtimeToken(): Promise<RealtimeTokenDto> {
  const { data } = await apiClient.post<RealtimeTokenDto>('/realtime/token/');
  return data;
}

/**
 * `POST /api/realtime/subscribe-token/` — one channel's JWT.
 *
 * The server re-runs the same authorization the REST endpoints run and answers
 * 403 for anything the caller may not read (backend ADR-021), so a rejection
 * here is an answer, not a transport failure.
 */
export async function getSubscribeToken(channel: string): Promise<SubscribeTokenDto> {
  const { data } = await apiClient.post<SubscribeTokenDto>('/realtime/subscribe-token/', {
    channel,
  });
  return data;
}
